export const viewValues = {
  // expires in
  '1m': 'anms.file.expiresIn.one_month',
  'NEVER': 'anms.file.expiresIn.never',
  '6m': 'anms.file.expiresIn.six_month',
  '1y': 'anms.file.expiresIn.one_year',
  '3y': 'anms.file.expiresIn.three_years',
  'now': 'anms.file.expires_in.now',

  // field names
  'gyazo-st': 'anms.stats.fields.field_name.gyazo-st',
  'gyazo': 'anms.stats.fields.field_name.gyazo',
  'gif': 'anms.stats.fields.field_name.gif',
  'd': 'anms.stats.fields.field_name.d',
  'vid': 'anms.stats.fields.field_name.vid',
  'st': 'anms.stats.fields.field_name.st',
};
